export default __webpack_public_path__ + "static/favicon-315728ebad6d37fbb8f5056c8004eedb.png";